module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "xy-box",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "xy-box-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "xy-box-model-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.type === 1 ? _vm.$t('all.yonghuxieyi') : _vm.$t('all.yinsixieyi')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/wode_jiazu@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xy-box-model-container"
  }, [_c('div', {
    staticClass: "xy-yszc"
  }, [_vm._v(_vm._s(_vm.data))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e274896a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xieyi/xieyi.vue
// module id = 834
// module chunks = 1